module.exports = __webpack_public_path__ + "media/images/offered-payment-plan-step-2-f266fcbc.png";